import React, { useEffect, useRef, useState } from 'react'
import { useFormContext, useFieldArray, FormProvider, useForm } from 'react-hook-form'
import { SelectInput, useTranslate, NumberInput, TextInput, required } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Skeleton, Typography } from '@mui/material'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import { operationTypeServices } from 'src/services/payment/operationType/operationType.service'
import { accountServices } from 'src/services/payment/account/account.service'
import { SplitByCharacterWithPosition } from 'src/helper/splitByCharacter'
import { usePaymentContext } from 'src/components/pages/payment/payment/context/paymentContext'
import { parseDateFormat } from 'src/helper/parseDateFormat'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'

export const CreditArray = ({ selectedBusinessUnit }) => {
  const translate = useTranslate()
  const { control, setValue } = useFormContext()
  const [loading, setLoading] = useState(false)
  const [operationTypes, setOperationTypes] = useState(false)
  const [creditsLoading, setCreditsLoading] = useState([])
  const { setPaymentCredit, currency } = usePaymentContext()
  const {
    fields: creditFields,
    replace
  } = useFieldArray({
    control,
    name: 'credit',
  })

  const initialCreditFieldsRef = useRef(null);
  const [reserveOptions, setReserveOptions] = useState()
  useEffect(() => {
    if (!initialCreditFieldsRef.current && creditFields.length > 0) {
      initialCreditFieldsRef.current = JSON.parse(JSON.stringify(creditFields));
      setReserveOptions(JSON.parse(JSON.stringify(creditFields)))
    }
  }, [creditFields]);

  const auxForm = useForm({})

  const formatCredits = (listCredit) =>
    listCredit?.map((credit) => {
      return {
        operation_type: credit?.operation_type_relation?.id,
        currency: credit?.currency_relation?.hash_currency,
        date_time: credit?.date_time,
        amount_pending: credit?.amount_pending,
        amount_to_pay: 0,
        id: credit?.id,
        name: credit?.name,
        hash_reservation: credit?.hash_reservation,
      }
    })

  useEffect(() => {
    getOperationType()
    getCredits()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getOperationType = async () => {
    try {
      setLoading(true)
      const options = await operationTypeServices.getByAll()
      if (options.length) {
        setOperationTypes(options)
        setLoading(false)
        return
      }
      setOperationTypes([])
      setLoading(false)
    } catch (error) {
      setOperationTypes([])
      setLoading(false)
    }
  }

  const getCredits = async () => {
    try {
      setCreditsLoading(true)
      const options = await accountServices.getCreditsByBusinessUnitId(
        selectedBusinessUnit?.hash_business_unit,
        currency?.hash_currency
      )
      if (options.length !== 0) {
        const credits = formatCredits(options)
        setValue('credit', credits)
        setPaymentCredit(credits)
        setCreditsLoading(false)
        return
      }
      setCreditsLoading(false)
      setPaymentCredit([])
    } catch (error) {
      setPaymentCredit([])
      setCreditsLoading(false)
    }
  }

  const validateAmountToUse = (amount_to_use, formData, data) => {
    let index = SplitByCharacterWithPosition(data.source, '.', 1)
    let total_amount = formData?.credit?.[index]?.amount_pending
    if (amount_to_use > total_amount) {
      return translate('ra.message.validate_amount_to_use')
    }
  }

  const uniqueByNameCreditArray = Object.values(
    reserveOptions?
    reserveOptions.reduce((acc, obj) => {
      acc[obj.name] = obj;
      return acc;
    }, {}):
    []
  );

  const searchReserves = async (reserve, length = 2) => {
      let searchTimeout
        clearTimeout(searchTimeout)
    
        searchTimeout = setTimeout(async () => {
            const reservesAux = initialCreditFieldsRef.current?.filter(rsv => rsv.name?.toLowerCase().includes(reserve?.name?.toLowerCase()))
            setReserveOptions(reservesAux)
        }, 1000)
      }

  return (
    <>
      {creditsLoading ? (
        <Skeleton variant='rectangular' width={'100%'} height={60} />
      ) : creditFields?.length === 0 && !creditsLoading ? (
        <Typography id='modal-modal-title' variant='h6' component='h3' margin={'20px'}>
          {translate('ra.message.no_have_credits')}
        </Typography>
      ) : (
        <>
        <FormProvider {...auxForm}>
          <MultiAutocompleteInput
            source='choice'
            options={uniqueByNameCreditArray}
            loading={creditsLoading}
            optionsText={['name']}
            multiple
            style={{width:'50%', marginBottom:'15px'}}
            optionValue='id'
            onSearch={searchReserves}
            resetOnLoad={false}
            fields={['name']}
            onChange={(e) => {
              if(e.target.value){
                /* setSelectedCredits(e.target.value?.map(credit=>credit.name)) */
                const names = e.target.value?.map(credit=>credit.name)
                if(names.length > 0){
                  replace(initialCreditFieldsRef.current?.filter(credit=>names.includes(credit.name)))
                } else {
                  replace(initialCreditFieldsRef.current)
                }
                
              }
            }}
            disablePortal={false}
          />
          </FormProvider>
        
        {React.Children.toArray(
          creditFields.map((field, index) => (
            <>
              <div key={field.id} className='payment_entity_container'>
                <div className='payment_entity_container_row'>
                  {/* <EditInputsWrap label={translate('ra.field.operation_type')}>
                    {loading ? (
                      <Skeleton variant='rectangular' width={300} height={40} />
                    ) : (
                      <SelectInput
                        source={`credit.${index}.operation_type`}
                        optionValue='id'
                        optionText='long_name'
                        sx={{ width: 300 }}
                        choices={operationTypes}
                        label={''}
                        disabled
                      />
                    )}
                  </EditInputsWrap> */}
                  <EditInputsWrap style={{width:'30%'}} label={translate('ra.field.reserve')}>
                    <label >{field.name}</label>
                  </EditInputsWrap>

                  {/* <EditInputsWrap label={translate('ra.field.currency')}>
                    {loading ? (
                      <Skeleton variant='rectangular' width={300} height={40} />
                    ) : (
                      <SelectInput
                        source={`credit.${index}.currency`}
                        optionValue='hash_currency'
                        optionText='short_name'
                        sx={{ width: 300 }}
                        choices={paymentCurrecies}
                        label={''}
                        disabled
                      />
                    )}
                  </EditInputsWrap> */}
                  <EditInputsWrap style={{width:'20%'}} label={translate('ra.field.date')}>
                    <label >{parseDateFormat(field.date_time)?.split(',')[0]}</label>
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.amount')}>
                    <label >{ numberFormatterWithDecimalAndThousand(field.amount_pending)}</label>
                    {/* <TextInput
                      source={`credit.${index}.amount_pending`}
                      label={''}
                      disabled
                      format={(record) => `${record.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`}
                    /> */}
                  </EditInputsWrap>
                  <EditInputsWrap label={translate('ra.field.amount_to_use')}>
                    <NumberInput
                      label={''}
                      source={`credit.${index}.amount_to_pay`}
                      sx={{ width: 300 }}
                      validate={validateAmountToUse}
                    />
                  </EditInputsWrap>
                </div>
              </div>
            </>
          ))
        )}
        </>
      )}
      <EditInputsWrap label={translate('ra.field.transaction_date')}>
          <DatePickers
            source={`date`}
            validate={[required()]}
            viewsShow={false}
          />
      </EditInputsWrap>
    </>
  )
}